export enum EnWsTrackStatus {
    open,
    completed,
    error
}
